import React from 'react';

import { Quantity } from 'src/components/atoms/Quantity/Quantity';
import { PriceBreakdownContainer } from 'src/components/molecules/PriceBreakdown/PriceBreakdownContainer';

export interface ProductOptionsDispatchProps {
  onChangeQuantity: (payload: { quantity: number; valid: boolean }) => void;
}

export interface ProductOptionsStateProps {
  inStock: boolean;
  quantity: number;
  showPriceBreakdown: boolean;
}

type ProductOptionsProps = ProductOptionsDispatchProps & ProductOptionsStateProps;

export const ProductOptions = ({
  inStock,
  onChangeQuantity,
  quantity,
  showPriceBreakdown,
}: ProductOptionsProps) => {
  if (!inStock) {
    return null;
  }

  return (
    <>
      {showPriceBreakdown && <PriceBreakdownContainer />}
      <Quantity
        defaultValue={quantity}
        onChange={(quantity, valid) => {
          onChangeQuantity({ quantity, valid });
        }}
      />
    </>
  );
};
